import _Object$keys from 'babel-runtime/core-js/object/keys';

export default {
  name: 'Repeat',
  props: {
    repeatType: {
      type: Number,
      default: 0
    },
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        repeatTime: '',
        repeatRate: '', // 重复频率
        endType: '1', // 结束类型
        endTypeConfig: '', // 结束次数/时间
        repetitionType: 0
      },
      endDate: '',
      endCount: '',
      repeatList: [{ label: '从不重复', value: 1 }, { label: '每天', value: 2 }, { label: '每周', value: 3 }, { label: '每月', value: 4 }, { label: '每年', value: 5 }],
      timeList: ['', '', '天', '周', '月', '年'],
      checkedRepeatTime: [],
      repeatTimeList: [{ label: '一', value: '1' }, { label: '二', value: '2' }, { label: '三', value: '3' }, { label: '四', value: '4' }, { label: '五', value: '5' }, { label: '六', value: '6' }, { label: '日', value: '7' }],
      dayList: [],
      rules: {
        repeatRate: [{ required: true, message: '重复频率不能为空', trigger: 'blur' }],
        endTypeConfig: [{ required: true, message: '请输入重复次数或结束日期', trigger: 'change' }],
        repeatTime: [{ required: true, message: '请选择重复时间', trigger: 'change' }]
      }
    };
  },

  watch: {
    endDate: function endDate(val) {
      this.form.endTypeConfig = val;
      this.$refs['ruleForm'].validateField('endTypeConfig');
    },
    endCount: function endCount(val) {
      this.form.endTypeConfig = val;
      this.$refs['ruleForm'].validateField('endTypeConfig');
    }
  },
  mounted: function mounted() {
    this.dayList = [];
    this.changeEndDate(1);
    this.form.repetitionType = this.repeatType;
    if (_Object$keys(this.detail).length) {
      this.form.repetitionType = this.detail.repetitionType;
      this.form.repeatTime = this.detail.repeatTime || '';
      this.form.repeatRate = this.detail.repeatRate || '';
      this.form.endType = this.detail.endType + '' || '';
      if (this.detail.endType == 2) {
        this.endCount = this.detail.endTypeConfig;
        this.endDate = '';
      } else if (this.detail.endType == 3) {
        this.endDate = this.detail.endTypeConfig;
        this.endCount = '';
      }
      this.form.endTypeConfig = this.detail.endTypeConfig;
      if (this.form.endType == 1 || !this.form.endType) {
        this.form.endTypeConfig = this.detail.endTypeConfig || 'useless';
      }
    }
    for (var i = 1; i <= 31; i++) {
      this.dayList.push(i);
    }
  },

  methods: {
    /**
     * 摘要文字
     */
    summaryText: function summaryText() {
      if (this.form.repetitionType === 1) {
        return '从不重复';
      } else if (this.form.repetitionType === 2) {
        return '\u6BCF' + this.form.repeatRate + '\u5929';
      } else if (this.form.repetitionType === 3) {
        return '\u6BCF' + this.form.repeatRate + '\u5468, \u5468' + this.checkedRepeatTime.join('、');
      } else if (this.form.repetitionType === 4) {
        return '\u6BCF' + this.form.repeatRate + '\u6708\uFF0C\u7B2C' + this.form.repeatTime + '\u5929';
      } else if (this.form.repetitionType === 5) {
        return '\u6BCF' + this.form.repeatRate + '\u5E74';
      }
    },


    /**
     * 改变结束类型
     */
    changeEndDate: function changeEndDate(value) {
      if (value == 1) {
        // 此值没有仅作为表单验证使用，没有任何意义
        this.form.endTypeConfig = 'useless';
        this.endDate = '';
        this.endCount = '';
      } else if (value == 2) {
        this.endDate = '';
        this.form.endTypeConfig = '';
      } else if (value == 3) {
        this.endCount = '';
        this.form.endTypeConfig = '';
      }
      this.$refs['ruleForm'].validateField('endTypeConfig');
    },


    /**
     * 改变重复类型
     */
    changeRepeat: function changeRepeat(value) {
      this.form = {
        repetitionType: value,
        repeatTime: '',
        repeatRate: '', // 重复频率
        endType: '1', // 结束类型
        endTypeConfig: '' // 结束次数/时间
      };
      this.changeEndDate(1);
    },


    /**
     * 改变重复时间
     */
    changeRepeatTime: function changeRepeatTime() {
      var _this = this;

      if (this.checkedRepeatTime.length) {
        var list = [];
        this.repeatTimeList.forEach(function (item) {
          _this.checkedRepeatTime.forEach(function (element) {
            if (item.label === element) {
              list.push(item.value);
            }
          });
        });
        this.form.repeatTime = list.join(',');
        this.$refs['ruleForm'].validateField('repeatTime');
      } else {
        this.form.repeatTime = '';
        this.$refs['ruleForm'].validateField('repeatTime');
      }
    }
  }
};